import { attachMailcheck } from "./utils/emailSuggest"

export class NewsletterSignup {
    private emailInput: HTMLInputElement | null;
    private companyInput: HTMLInputElement | null;
    private button: HTMLButtonElement | null;
    private message: HTMLElement | null;
    private suggestionBox: HTMLElement | null;

    constructor() {
        this.emailInput =
            document.querySelector<HTMLInputElement>("#newsletterEmail");
        this.companyInput =
            document.querySelector<HTMLInputElement>("#newsletterCompany");
        this.button =
            document.querySelector<HTMLButtonElement>("#newsletterBtn");
        this.message =
            document.querySelector<HTMLElement>("#newsletterMessage");
        this.suggestionBox =
            document.querySelector<HTMLElement>("#newsletterSuggestion");

        if (!this.emailInput || !this.button) return;

        if (this.suggestionBox) {
            attachMailcheck(this.emailInput, this.suggestionBox);
        }

        this.button.addEventListener("click", () => this.submit());
    }

    private showMessage(text: string, isError = false) {
        if (!this.message) return;

        this.message.textContent = text;
        this.message.style.display = "block";
        this.message.style.color = isError ? "#dc3545" : "#198754";
    }

    private async submit() {
        if (!this.emailInput || !this.button) return;

        const email = this.emailInput.value.trim();

        if (!email) {
            this.showMessage("Please enter your email address.", true);
            return;
        }

        // Honeypot (bots only)
        if (this.companyInput?.value) return;

        this.button.disabled = true;

        try {
            const res = await fetch("/api/newsletter/subscribe", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email,
                    company: this.companyInput?.value ?? ""
                })
            });

            if (res.status === 429) {
                this.showMessage(
                    "You're subscribing too quickly — please wait a moment.",
                    true
                );
                this.button.disabled = false;
                return;
            }

            if (!res.ok) {
                this.showMessage(
                    "Something went wrong. Please try again later.",
                    true
                );
                this.button.disabled = false;
                return;
            }

            // ✅ SUCCESS
            this.showMessage("Thanks for subscribing!");
            this.emailInput.value = "";

            // 🔒 Permanently disable button after success
            this.button.textContent = "Subscribed";
            this.button.disabled = true;
        }
        catch {
            this.showMessage(
                "Network error. Please try again later.",
                true
            );
            this.button.disabled = false;
        }
    }
}
